import { useGetProrations } from "hooks/useGetProrations";
import { OrderProperty } from "types/order";
import { LEDGER_CODE_PRORATION_PRORATED } from "utils/constants";

type Params = {
  orderId: string,
  selectedProperty: OrderProperty,
}

type PropertyTaxAndProration = {
  prorationId: string,
  description: string,
  amount: number
}

export const useTaxesAndProrations = ({
  orderId,
  selectedProperty
}: Params) => {
  const {
    data: prorationsResponse,
    isLoading: isProrationsLoading
  } = useGetProrations({
    orderId,
    queryConfig: {
      staleTime: 50 * (60 * 1000)
    }
  });

  const propertyProrations = prorationsResponse?.getOrder.prorations
    .filter((proration) => proration.estate._id === selectedProperty._id) ?? [];

  const prorations: PropertyTaxAndProration[] = propertyProrations.map((proration) => {
    const proratedAmount = proration.accounting.find((entry) => entry.code.includes(LEDGER_CODE_PRORATION_PRORATED));
    return {
      prorationId: proration._id,
      description: proration.description,
      amount: proratedAmount?.amount ?? 0
    };
  });

  return ({
    prorations,
    isProrationsLoading
  });
};